import script from "./AccountMenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountMenuView.vue?vue&type=script&setup=true&lang=js"

import "./AccountMenuView.vue?vue&type=style&index=0&id=0c246527&scoped=true&lang=css"

import exportComponent from "/Users/henry/ionic/verbalchess_ionic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c246527"]])

export default __exports__